import { z } from 'zod';

/**
 * Query parameter shape for `GET /invoices/:id/export` (#52, REQ3.8).
 *
 * The endpoint returns the binary body directly (Content-Disposition:
 * attachment); only the *request* shape lives in `@invoice/shared` so the
 * frontend builds the URL from one canonical schema.
 */
export const InvoiceExportFormatEnum = z.enum(['json', 'xml']);
export type InvoiceExportFormat = z.infer<typeof InvoiceExportFormatEnum>;

export const InvoiceExportQuerySchema = z.object({
  format: InvoiceExportFormatEnum,
});
export type InvoiceExportQuery = z.infer<typeof InvoiceExportQuerySchema>;
